import React from "react";

const sections = [
  {
    title: "Purchases and pricing",
    content: [
      "By placing an order, you agree that the details you provide are accurate and that you are",
      "authorised to use the selected payment method. Product availability, prices, offers and",
      "delivery estimates may change, and we may correct clear errors before accepting an order.",
    ].join(" "),
  },
  {
    title: "Cancellations",
    content: [
      "Cancellation availability depends on the current order stage. Where cancellation is",
      "available,",
      "you can use the order controls in your account. Orders that have already been processed,",
      "shipped or delivered may not be cancellable.",
    ].join(" "),
  },
  {
    title: "Returns and refunds",
    content: [
      "Return eligibility follows the policy shown on the relevant product page and any applicable",
      "consumer law. Some items may be non-returnable for hygiene, safety or product-specific",
      "reasons. Approved refunds are processed to the original payment method or as otherwise",
      "communicated to you.",
    ].join(" "),
  },
  {
    title: "Your responsibilities",
    content: [
      "Keep your account details accurate, protect your sign-in credentials, use the store",
      "lawfully",
      "and do not interfere with its security or availability. You are responsible for activity",
      "carried",
      "out through your account unless you notify us promptly of unauthorised use.",
    ].join(" "),
  },
  {
    title: "Changes to these terms",
    content: [
      "We may update these terms to reflect operational, legal or product changes. If a material",
      "update requires your acknowledgement, we will ask you to review it when you next use",
      "your",
      "account.",
    ].join(" "),
  },
];

export default function TermsAndConditions() {
  return (
    <article
      className="mx-auto max-w-3xl px-4 py-14 sm:px-8"
      data-testid="terms-and-conditions-page"
    >
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#8C6D46]">
        Eira Products
      </p>
      <h1 className="mt-4 font-serif text-4xl font-semibold text-[#1E2A24] sm:text-5xl">
        Terms &amp; Conditions
      </h1>
      <p className="mt-5 text-sm leading-7 text-[#64748B]">
        These terms apply when you browse, create an account or purchase from Eira Products.
      </p>
      <div className="mt-10 space-y-9">
        {sections.map((section) => (
          <section
            key={section.title}
            data-testid={`terms-section-${section.title.toLowerCase().replaceAll(" ", "-")}`}
          >
            <h2 className="font-serif text-2xl font-semibold text-[#1E2A24]">
              {section.title}
            </h2>
            <p className="mt-3 text-sm leading-7 text-[#4B5563]">
              {section.content}
            </p>
          </section>
        ))}
      </div>
    </article>
  );
}